import React from "react";

import Colors from "../../../../stories/assets/Colors";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../stories/Button/Button";
import classes from "./UnBanModal.module.css";
import { CheckCircleIconGreen } from "../../../../constant/imagePath";
import Fonts from "../../../../stories/assets/Fonts";
const UnBanModal = ({ show, setShow }) => {
  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"468px"}
        height={"188px"}
        padding={"32px"}
        showCloseIcon={false}
      >
        <div className={classes.modalContent}>
          <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
            Unban Sarika Bhimre?
          </h4>
          <div className={classes.modalButtons}>
            <Button size="Large" label="Cancel" customStyle={{ width: "max-content" }}
              onClick={() => setShow(false)}
            />
            <Button
              primary={true}
              size="Large"
              label="Unban"
              customStyle={{
                width: "max-content",
              }}
              onClick={() => setShow(false)}

            />
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default UnBanModal;
